export const POPUP_AUTH_COMPLETE_MESSAGE_TYPE = 'portal-oauth-complete';
export const POPUP_LOGOUT_COMPLETE_MESSAGE_TYPE = 'portal-oauth-logout-complete';
export const POPUP_LOGOUT_COMPLETE_PATH = '/api/auth/popup-logout-complete';
